@if (data) {
  <rt-feature-tooltip
    [arrowPosition]="arrowPosition"
    [isNew]="data.isNew"
    [title]="data.title"
    [description]="data.description"
    [learnMore]="data.learnMore"
    [learnMoreCopy]="data.learnMoreCopy"
    (learnMoreClick)="learnMoreClick$.emit()"
    (close)="close$.emit()"
  ></rt-feature-tooltip>
}
